function NotFound404() {
    return (

        <>
        <center><h1>404 Not Found</h1></center>
        <hr/>
        </>

    );
}

export default NotFound404;